let setCustomers = (state, customers) => {
	state.customers = customers;
};

export default { setCustomers };
